export interface Country {
    alpha_2_code: string;
    alpha_3_code: string;
    short_name: string;
    english_short_name: string;
}
